// Invented demo data. Replace with API data once the section endpoints exist.
export const ORGANIZATION = { name: "Ravnar" } as const;

/**
 * The demo organization's owner in the local API (apps/backend/lib/api/local-services.ts), which `pnpm dev` and the
 * end-to-end tests run against. Development builds show it on the login page as a hint; keep the two in sync.
 */
export const DEMO_ACCOUNT = { email: "admin@demo.example", password: "ravnar-demo" } as const;

/**
 * The local API emails nothing, so it confirms every new organization with this code (LOCAL_CONFIRMATION_CODE in
 * apps/backend/lib/api/local-services.ts). Development builds show it where the code is asked for; keep the two in sync.
 */
export const LOCAL_CONFIRMATION_CODE = "123456";

/**
 * The local API has no authenticator app to check a code against, so it accepts this one as well as a real one
 * (LOCAL_MFA_CODE in apps/backend/lib/api/local-services.ts). Development builds show it; keep the two in sync.
 */
export const LOCAL_MFA_CODE = "123456";

/** Every demo figure is anchored on this calendar date. */
export const DEMO_TODAY = "2026-09-13";
